module.exports = __webpack_public_path__ + "static/img/4.3675280.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/store_files/images/ftb/4.jpg
// module id = UEBY
// module chunks = 0